import { Injectable } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import ModalService from '../../../../old-crazy-web-frontend/src/app/utils/modal/modal.service';

@Injectable()
export class Ng1ModalService {
  public modalService: ModalService;

  constructor(private configService: ConfigService) {
    this.modalService = configService.getValue('ModalService');
  }

  get lazyModalService(): ModalService {
    if (!this.modalService) {
      this.modalService = this.configService.getValue('ModalService');
    }
    return this.modalService;
  }
}
